module.exports = __webpack_public_path__ + "img/BAHA.919588d1.svg";